// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#teachingRoom[data-v-bcec0452] {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  height: calc(100vh - 82px);\n}\n[data-v-bcec0452] .fcr-w-screen {\n  width: 100% !important;\n}\n[data-v-bcec0452] .fcr-h-screen {\n  height: 100% !important;\n}\n[data-v-bcec0452] .classroom-viewport {\n  width: 100% !important;\n  height: 100% !important;\n}\n[data-v-bcec0452] .toolbar-position {\n  right: 10px !important;\n  z-index: 30 !important;\n}\n", ""]);
// Exports
module.exports = exports;
